import React from 'react'
import Link from 'gatsby-link'

import './testimonials.css'

const Testimonials = () => (
  <div
    style={{
      margin: '1.45rem 0',
      padding: '80px 0 50px 0'
    }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-10 offset-lg-1 text-center">
          <h1>Testimonials</h1>

          <p>At Ridley Owen &amp; Sons, we take pride in a job well done. We’re proud of 
            the work we do, and our customers are happy with the results.
            You don’t need to take our word for it either – here’s what our customers 
            have to say.
          </p>

          <div className="testimonial">
            <p>We choose our builders based of high recommendation. Reliability was very
              important to us as we were going to be out of the country during the works
              and Ridley Owen &amp; Sons lived up to expectations. Our extension and 
              garage conversion was completed ahead of schedule, to a high standard and 
              with no extra costs. My neighbours reported no issues and the site was 
              always tidy at the end of the day. I would not hesitate in recommending 
              them.</p>

            <p><strong>Jannet &amp; Chris</strong><br />Home extension - Hoddesdon, 
            Hertfordshire</p>
          </div>

          <div className="testimonial">
            <p>We needed various work done to include gutters and facias and our 
              downstairs cloakroom and hallway, we had no idea who to employ to do the 
              work. From beginning to end Glenn and his team were professional, courteous,
              punctual and the standard of work was excellent. Cannot recommend Ridley 
              Owen &amp; Sons highly enough and we will definitely be using them again.
              </p>
              <p><strong>Michael</strong><br />Property Maintenance - Brentwood, 
              Essex</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Testimonials


// WEBPACK FOOTER //
// ./src/components/Testimonials/index.js